export default __webpack_public_path__ + "static/media/dds5168b-1.dbc6da4f.png";